import React from "react";

import { BoxProps } from "@mui/material";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { PRODUCT_CAROUSEL_CLASSES } from "./constants";

export interface StyleProps {
  isRightLayout?: boolean;
  isNewInCarousel?: boolean;
}

const FilteredBox = ({
  isRightLayout,
  isNewInCarousel,
  ...restProps
}: StyleProps & BoxProps) => <Box {...restProps} />;

export const ProductCarouselContainer = styled(FilteredBox)(({
  theme,
  isRightLayout,
  isNewInCarousel,
}) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    position: "relative",
    marginBottom: theme.spacing(7),
    [BREAKPOINT_TABLET]: {
      marginBottom: theme.spacing(9),
    },
    [BREAKPOINT_DESKTOP]: {
      marginBottom: theme.spacing(16),
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.header}`]: {
      display: "flex",
      flexDirection: "column",
      zIndex: 1000,
      ...theme.typography.h4,
      textTransform: "inherit",
      alignItems: isRightLayout ? "flex-start" : "flex-end",
      paddingRight: isRightLayout ? theme.spacing(0) : theme.spacing(2),
      paddingLeft: isRightLayout ? theme.spacing(2) : theme.spacing(0),
      [BREAKPOINT_TABLET]: {
        paddingRight: isRightLayout ? theme.spacing(0) : theme.spacing(4),
        paddingLeft: isRightLayout ? theme.spacing(4) : theme.spacing(0),
        ...theme.typography.h3,
        textTransform: "inherit",
      },
      [BREAKPOINT_DESKTOP]: {
        position: "absolute",
        top: theme.spacing(5),
        ...theme.typography.h2,
        textTransform: "inherit",
        alignItems: "flex-start",
        right: !isRightLayout ? theme.spacing(8) : "inherit",
        left: isRightLayout ? theme.spacing(8) : "inherit",
        paddingRight: theme.spacing(0),
        paddingLeft: theme.spacing(0),
        width: "30.26%",
      },
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.swiper}`]: {
      display: "flex",
      alignItems: "flex-end",
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.element}`]: {
      height: "100%",
      padding: theme.spacing(0, 2),
      marginRight: !isRightLayout ? theme.spacing(-2) : "unset",
      marginLeft: isRightLayout ? theme.spacing(-2) : "unset",
      [BREAKPOINT_TABLET]: {
        padding: theme.spacing(0, 3),
        marginRight: !isRightLayout ? theme.spacing(-3) : "unset",
        marginLeft: isRightLayout ? theme.spacing(-3) : "unset",
      },
      [BREAKPOINT_DESKTOP]: {
        padding: "0 5.604%",
        marginRight: !isRightLayout ? "-5.604%" : "unset",
        marginLeft: isRightLayout ? "-5.604%" : "unset",
      },
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.slider}`]: {
      height: "auto",
      width: "calc(100% / 2)",
      [BREAKPOINT_TABLET]: {
        width: "calc(100% / 3) !important",
      },
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.container}`]: {
      overflow: "hidden",
      flexGrow: 1,
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.elements}`]: {
      width: "162.116991%",
      transform:
        !isRightLayout && !isNewInCarousel ? "translate(-38.316151%, 0)" : "none",
      [BREAKPOINT_TABLET]: {
        width: "120.65211739%",
        transform:
          !isRightLayout && !isNewInCarousel
            ? "translate(-16.65217391%, 0)"
            : "none",
      },
      [BREAKPOINT_DESKTOP]: {
        width: "125.996284%",
        transform:
          !isRightLayout && !isNewInCarousel ? "translate(-20.692580%, 0)" : "none",
      },
      "& .swiper-wrapper": {
        alignItems: "stretch",
        height: "auto !important",
      },
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.buttons}`]: {
      width: theme.spacing(2),
      minWidth: theme.spacing(2),
      paddingBottom: theme.spacing(15),
      zIndex: 1001,
      textAlign: !isRightLayout ? "left" : "right",
      [BREAKPOINT_TABLET]: {
        width: theme.spacing(4),
        minWidth: theme.spacing(4),
      },
      [BREAKPOINT_DESKTOP]: {
        width: "27.604%",
        minWidth: "27.604%",
      },
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.button}`]: {
      display: "none",
      [BREAKPOINT_DESKTOP]: {
        display: "inline-flex",
      },
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.buttonLeft}`]: {
      [BREAKPOINT_DESKTOP]: {
        marginLeft: !isRightLayout ? "17.735%" : "unset",
      },
    },
    [`& .${PRODUCT_CAROUSEL_CLASSES.buttonRight}`]: {
      [BREAKPOINT_DESKTOP]: {
        marginRight: isRightLayout ? "17.735%" : "unset",
      },
    },
  };
});
